import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiAppearanceSidebarEditComponent } from '@fi-app/appearance/sidebar/edit/sidebar-edit/sidebar-edit.component';
import { WidgetService } from '@fi-app/widget/widget.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAppearanceResolve_SiteDesignId } from '@fi-app/appearance/states/appearance-start-page-edit-state';

export const FiAppearanceSidebarEditState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.Sidebar.Edit,
    url: '/Edit?{:siteDesignId}',
    views: {
        '@': {
            component: FiAppearanceSidebarEditComponent,
        },
    },
    resolve: {
        siteDesignId: FiAppearanceResolve_SiteDesignId,
        widgets: ['siteDesignId', WidgetService, FiAppearanceSidebarEditStateResolveWidgets],
        pageTitle: [PageTitleService, FiAppearanceSidebarEditStateResolvePageTitle],
    },
};

export function FiAppearanceSidebarEditStateResolveWidgets(siteDesignId: number, widgetService: WidgetService) {
    return widgetService.getWidgets(ObjectTypes.SideBar, {
        isEditMode: true,
        siteDesignId: siteDesignId,
    });
}

export function FiAppearanceSidebarEditStateResolvePageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleByTextId('common.appearance');
}
